/* eslint-disable import/no-anonymous-default-export */
export default {
  copyright: "Copyright",
  "footer.companyPrefix": "Una empresa",
  "navBar.lang": "Idiomas",
  "layout.user.link.help": "ayuda",
  "layout.user.link.privacy": "política de privacidad",
  "layout.user.link.terms": "términos de servicios",
  "app.home.introduce": "Ayuda",
  "app.forms.basic.title": "Formulario básico",
  "app.forms.basic.description":
    "Las páginas de formulario se utilizan para recopilar y verificar la información de los usuarios y los formularios básicos son comunes en escenarios donde existen algunos formatos de información.",

  areYouSureYouWantToAccept: "¿Estás seguro de que quieres aceptar?",
  areYouSureYouWantToRemove: "¿Estás seguro de que quieres eliminar?",
  areYouSureYouWantToEdit: "¿Estás seguro de que quieres editar?",
  areYouSureYouWantToClone: "¿Estás seguro de que quieres clonar?",
  areYouSureYouWantToUndo: "¿Estás seguro de que quieres deshacer?",
  areYouSureYouWantToCancel: "¿Estás seguro de que quieres cancelar?",
  dataRecoveredSuccessfully: "Datos recuperados con éxito",
  "yes.IWant": "Sí, quiero",
  youDontHavePermission: "No tienes permiso para realizar esta acción.",
  loading: "...",
  pleaseWait: "Por favor, espera",
  ok: "Ok",
  others: "Otro(s)",
  number_of_visitors: "Número de clientes",
  transfer: "Transferir",
  hasten: "Anticipar (retiro)",
  "loading-more": "Cargar más",
  version: "Versión",
  shortVersion: "v",
  refresh: "Actualizar",
  search: "Buscar",
  continue: "Continuar",
  edit: "Editar",
  cancel: "Cancelar",
  close: "Cerrar",
  submit: "Guardar",
  status: "Estado",
  reset: "Limpiar",
  options: "Opciones",
  settings: "Configuraciones",
  general: "General",
  email: "Correo electrónico",
  cellphone: "Celular",
  telephone: "Teléfono",
  create: "Crear",
  update: "Actualizar",
  delete: "Eliminar",
  clone: "Clonar",
  resendEmail: "Reenviar correo",
  language: "Idioma",
  all: "Todos",
  "picture.upload": "Subir",
  "picture.remove": "Eliminar imagen",
  "picture.onDrag": "Suelta Aquí",
  add: "Agregar",
  balanceTotal: "Saldo Total",
  balanceNotConciliationTotal: "Saldo Total",
  balanceConciliationTotal: "Saldo Conciliado",
  balanceNotRevenueTotal: "Previsto",
  balanceRevenueTotal: "Realizado",
  enabled: "Activo",
  disabled: "Inactivo",
  createdAt: "Creado en",
  updatedAt: "Actualizado en",
  acceptedAt: "Aceptado en",
  canceledAt: "Cancelado en",
  createdBy: "Creado por",
  updatedBy: "Actualizado por",
  acceptedBy: "Aceptado por",
  requestBy: "Solicitado por",
  canceledBy: "Cancelado por",
  dateFormat: "DD/MM/YYYY",
  statement: "Extrato",
  until: "hasta",
  today: "Hoy",
  yesterday: "Ayer",
  lastFortnight: "Últimos 15 días",
  nextFortnight: "Próximos 15 días",
  thisMonth: "Este Mes",
  thisYear: "1 Año (A partir de hoy)",
  goBack: "Volver",
  calendar: "Agenda",
  lastUpdate: "Última actualización",

  filteredBy: "Filtrado por",
  filter: "Filtrar",
  "filter.clean": "Limpiar Filtros",

  "link.expired": "Enlace expirado",

  mail_sent: "Correo enviado",
  mail_sent_to: "Correo enviado a",
  "send.to.mail": "Envío por Correo",
  "recovery.with.success": "¡Actualizado con éxito!",
  "follow.procedure.sent.email": "Sigue el procedimiento enviado al correo",
  "button.create": "Crear",
  "button.new": "Nuevo",
  "button.new.link": "Nuevo enlace",
  "button.add": "Agregar",
  "button.add.and.choice": "Agregar y Usar",
  "button.update": "Actualizar",
  "button.update.and.choice": "Actualizar y Usar",
  "button.select": "Seleccionar",
  "button.select.recipient": "Seleccionar destinatario(s)",
  "button.send": "Enviar",
  "button.share": "Compartir",
  "button.download": "Descargar",
  "button.download.loadingMessage":
    "Tu archivo está siendo procesado, cuando esté listo estará disponible para ti (no recargues la página)",
  "button.view": "Visualizar",
  "button.copy": "Copiar",
  "button.copy.success": "Copiado con éxito",
  "button.copy.link": "Copiar enlace",
  "button.copy.link.success": "Enlace copiado con éxito",

  "clean.selected": "Limpiar selección",
  "items.selected": "Item(s) seleccionado(s) ",
  "yesno.true": "Sí",
  "yesno.false": "No",
  "yes.confirm": "Confirmar",
  "no.cancel": "Cancelar",
  "no.close": "Cerrar",
  "yes.finish": "Finalizar",
  "joinplace.welcome": "Gestionando PROYECTOS, construyendo sueños.",
  "joinplace.slogan": "Todos tus proyectos se encuentran aquí",
  "joinplace.slogan.register": "Tu registro está siendo creado",
  "joinplace.welcome.register": "Construyendo sueños...",
  "joinplace.aboutus": "Sobre Joinplace",
  "joinplace.benefits": "Ventajas",
  "joinplace.visitus": "Visita nuestro sitio",

  production: "Producción",
  homologation: "Homologación",
  "normalizeRule.SOURCE": "Igual del origen",
  "normalizeRule.NUMERIC": "Solo números",
  "normalizeRule.ZERO_NUMERIC": "Solo números e Inclusión del cero inicial",
  "normalizeRule.ZERO": "Inclusión del cero inicial",

  "provided.conducted": "Previsto / Realizado",
  service: "Servicio",
  revenue: "Ingresos",
  received: "Recibido",
  late: "Atrasado",
  expenses: "Gastos",
  paidOut: "Pagado",
  predicted: "Previsto",
  choose: "Elegir",

  "modal.close.title": "¿Estás seguro de que quieres salir?",
  "modal.close.description":
    "Si sales perderás la información modificada sin guardar.",

  nextInvoice: "Próxima factura",
  "nextInvoice.message": "El próximo boleto estará disponible el día ",

  total: "Total",
  value: "Valor",
  date: "Fecha",

  next: "Siguiente",
  previous: "Anterior",
  done: "Finalizar",
  export: "Exportar",
  import: "Importar",

  empty: " ",

  "required.message": "es necesario",
  "insert.message": "Por favor, ingresa el",

  I: "Yo, {name},",
  "terms.confirm.description.terms": `confirmo que leí y acepto los`,
  "terms.confirm.description.privacy": `y la`,
  "terms.confirm.description.joinplace": `de la plataforma Joinplace`,

  "resend.mail.success.message": "Correo enviado con éxito.",
  "resend.mail.error.message": "Ocurrió un error al enviar el correo.",

  without_message: "Sin Información",

  file: "Archivo",
  "upload.click-or-drag-file-text":
    "Haz clic o arrastra el archivo a esta área para subirlo",
  "upload.click-or-drag-file-cert.hint":
    "Soporte para subida única con extensiones .pfx o .pcs12",
  "upload.click-or-drag-file-ofx.hint":
    "Soporte para subida única con extensión .ofx",
  "upload.click-or-drag-file-default.hint":
    "Soporte para subida única o múltiple con extensiones .xls, .xlsx, .doc, .docx, .pdf, .png, .jpg, .txt",

  "upload.failed.message": "falló en la subida",
  "upload.success.message": "enviado con éxito",
  "upload.removed.message": "eliminado con éxito",
  "upload.failed.removed.message": "falló al ser eliminado",

  "btnShowCurrency.true": "Ocultar valores",
  "btnShowCurrency.false": "Mostrar valores",

  "taxNumber.choose.type": "Elige el tipo de persona",
  "taxNumber.validate.PP.message": "Por favor, ingresa un CPF válido.",
  "taxNumber.validate.LP.message": "Por favor, ingresa un CNPJ válido.",
  "email.invalid.message": "Por favor, ingresa un correo electrónico válido.",

  "nickname.validate.character":
    "Debe contener solo caracteres especiales . _ -",
  "nickname.validate.space": "No puede contener espacios en blanco.",
  "nickname.validate.smallLetters": "Debe contener solo letras minúsculas.",
  "nickname.validate.maxLenght": "Debe contener máximo 32 caracteres.",
  store: "Almacenamiento",
  users: "Usuarios",
  in: "de",
  used: "usados",
  "page.title.projectItemList": "Elementos Compartidos",
};
